module.exports = __webpack_public_path__ + "media/site/images/products/mttr_calc@2x-6d9a90d81cff2e5a8afcee826e1b65b1.png";